import { defineComponent as _defineComponent } from 'vue'
import copy from 'copy-to-clipboard';
import { computed, ref } from 'vue';
import usePwa from '@/composables/pwa';
import store from '@/store/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PwaInfo',
  setup(__props) {

const { userAgent } = window.navigator;
const { isPwa } = usePwa();

const fcmToken = computed(() => store.getters.fcmToken as string | null);

const copyToken = () => {
  if (!fcmToken.value) return;
  copy(fcmToken.value);
};

const registrationActive = ref('');
navigator.serviceWorker.getRegistration().then((r) => { registrationActive.value = r?.active?.state || ' - '; });

const debugInfo = computed(() => ({
  user_agent: userAgent,
  is_pwa: isPwa.value,
  version: `web_${process.env.VUE_APP_VERSION}`,
  registration: registrationActive,
}));

const checkForUpdates = () => {
  navigator.serviceWorker.getRegistration().then((r) => (r ? r.update() : console.log('Service Worker Not Found')));
};


return { __sfc: true,userAgent, isPwa, fcmToken, copyToken, registrationActive, debugInfo, checkForUpdates }
}

})